<template>
    <v-container fluid>
    
        <v-card flat>
            <v-toolbar>
                <v-icon>post_add</v-icon>
                <v-toolbar-title class="font-weight-light"> 
                    <v-row>
                        <v-col >
                            <div>Alta de Notas de Crédito Fiscales</div>
                        </v-col>
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>                    
            </v-toolbar>

            <v-card-text>
                <v-container fluid>
                    <v-row v-if="!selectedPersona" dense>
                            <v-col>
                                <span>Seleccione a una Persona</span>
                            </v-col>
                        </v-row>

                        <v-row align="center" v-if="!selectedPersona">
                            <v-col cols="12"> 
                                <app-busqueda-personas :personaSeleccionada="setPersona"></app-busqueda-personas>
                            </v-col>
                        </v-row>

                        <v-row v-if="selectedPersona">
                            <v-col>
                                <span>Persona seleccionada</span>
                            </v-col>
                        </v-row>

                        <v-row align="center" v-if="selectedPersona">
                            <v-col cols="4">
                                <v-text-field v-model="selectedPersona.cui" label="CUI(L/T) " key="cuil" :disabled="true"></v-text-field>                    
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="selectedPersona.nombreCompleto" label="Nombre" :disabled="true"></v-text-field>                        
                            </v-col>
                            <v-col cols="4">
                                <v-btn color="warning" small text  @click="limpiar">Cancelar</v-btn>
                            </v-col>
                        </v-row>

                    <v-row v-if="selectedPersona">
                        <v-radio-group v-model="realizarNotaPara" column>
                            <template v-slot:label>
                                Realizar la Nota de Crédito
                            </template>
                            <v-radio value="ReversarComprobante" label="para Reversar Comprobante"></v-radio>
                            <v-radio value="Puntual" label="Puntual"></v-radio>
                        </v-radio-group>
                    </v-row>

                    <!-- lista de facturas y notas de débito de la persona -->
                    <v-container fluid v-if="selectedPersona && realizarNotaPara == 'ReversarComprobante'">
                        <v-card>
                            <v-card-title >
                                <span class="title">Aplicar A</span>                         
                            </v-card-title>
-
                            <v-row >
                                <v-col>
                                    <v-card >
                                    <v-card-title>
                                        <span v-if="!loadingComprobantes" >Facturas y Notas de Débito</span>
                                        <span v-if="loadingComprobantes" class="green--text"> (Consultando Comprobantes de la Persona... <v-progress-circular indeterminate size="24" color="green" ></v-progress-circular>)</span>
                                    </v-card-title>

                                    <!-- deudas de la persona -->
                                    <v-container fluid v-if="listComprobantes.length > 0">

                                       <v-data-table dense
                                            :headers="headersComprobantes"
                                            :items="listComprobantes"
                                            v-model="selectedComprobante"
                                            :loading="loading"  
                                            class="elevation-1"
                                            hide-default-footer
                                            item-key="id"                    
                                            >
                                            <template v-slot:item="{item}">
                                                <tr>
                                               <td class="text-xs-left">                
                                                   <v-icon v-if="listComprobantesAReversar.find(i=> i.comprobanteId === item.id) == null" 
                                                        color="green" @click="addComprobante(item)">add</v-icon>  
                                                    <v-icon v-else color="green" @click="quitarComprobante(item)">remove</v-icon> 
                                                </td>
                                                <td class="text-xs-left caption">{{ item.tipo }}</td>
                                                <td class="text-xs-left caption">{{ item.origen }}</td>
                                                <td class="text-xs-left caption">{{ item.numero }}</td>
                                                <td class="text-xs-left caption"> {{ item.fecha | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}}</td>
                                                <td class="text-xs-left caption">{{ item.importe | currency }}</td>
                                                <td class="text-xs-left caption"><v-chip small :color="item.empresaColor" label dark>{{item.empresaShort}}</v-chip></td>
                                                </tr>
                                            </template>
                                       </v-data-table>

                                        <v-row>
                                            <v-col cols="12"> 
                                            <v-card>
                                                <v-card-title>
                                                    <span class="title">Comprobantes a Reversar</span>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-row class="caption" no-gutters>
                                                        <v-col cols="9" class="font-weight-bold">Detalle</v-col>
                                                        <v-col cols="2" class="text-right font-weight-bold">Importe</v-col>
                                                        <v-col cols="1" class="text-right font-weight-bold"></v-col>
                                                    </v-row>
                                                    <template v-for="(item, index) in listComprobantesAReversar">
                                                        <v-row  class="caption" no-gutters :key="index">
                                                            <v-col cols="9">
                                                                <span class="caption">- {{item.tipo}} N° {{item.numero}} del {{item.fecha | dateParse() | dateFormat('DD/MM/YY')}}</span>
                                                            </v-col>
                                                            <v-col cols="2"><div class="text-right" >{{item.importe | currency}}</div></v-col>
                                                            <v-col cols="1"><div class="text-right" ><v-icon color="red" small @click="quitarComprobante(item)">clear</v-icon></div></v-col>
                                                        </v-row>
                                                    </template>
                                                    <v-divider></v-divider>
                                                    <v-row class="caption" no-gutters>
                                                        <v-col cols="9" class="text-center font-weight-bold">TOTAL</v-col>
                                                        <v-col cols="2" class="text-right font-weight-bold">{{totalAReversar | currency}}</v-col>
                                                        <v-col cols="1" class="text-right font-weight-bold"></v-col>
                                                    </v-row>
                                                </v-card-text>
                                                <v-divider></v-divider>
                                            </v-card>
                                            </v-col> 
                                        </v-row>
                                    </v-container>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-container>

                    
                    <v-container v-if="selectedPersona && realizarNotaPara=='Puntual'">
                        <h1>Ingrese los cargos</h1>
                        <v-row>
                            <v-col cols="6">
                                <v-autocomplete v-model="cargoAAgregarId" :items="cargos"
                                    item-text="descripcion" item-value="id" label="Cargo:" placeholder="Seleccione un cargo a Agregar">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Importe" v-model="importeCargoAAgregar"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text icon color="green" v-on="on" @click="agregarCargo">
                                        <v-icon>add</v-icon>
                                        <!-- <v-icon v-else>favorite_border</v-icon> -->
                                        </v-btn>
                                    </template>
                                    Agregar un Cargo
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row class="caption" no-gutters>
                            <v-col cols="9" class="font-weight-bold">Detalle</v-col>
                            <v-col cols="2" class="text-right font-weight-bold">Importe</v-col>
                            <v-col cols="1" class="text-right font-weight-bold"></v-col>
                        </v-row>
                        <template v-for="(item, index) in listCargosAAplicar">
                            <v-row  class="caption" no-gutters :key="index">
                                <v-col cols="9">
                                    <span v-if="item.item" class="caption">Cargo: {{item.cargoDescripcion}} - Cta. Nº {{item.item.numero}}, Vto. {{item.item.vencimiento | dateParse() | dateFormat('MM/YY')}} del Cred. Nº <span class="font-italic font-weight-medium"> {{item.numero}} </span></span>
                                    <span v-else                        class="caption">Cargo: {{item.cargoDescripcion}}</span>
                                </v-col>
                                <v-col cols="2"><div class="text-right" >{{item.importeAAplicar | currency}}</div></v-col>
                                <v-col cols="1"><div class="text-right" ><v-icon color="red" small @click="quitarCargo(item)">clear</v-icon></div></v-col>
                            </v-row>
                        </template>
                        <v-divider></v-divider>
                        <v-row class="caption" no-gutters>
                            <v-col cols="9" class="text-center font-weight-bold">TOTAL</v-col>
                            <v-col cols="2" class="text-right font-weight-bold">{{totalCargos | currency}}</v-col>
                            <v-col cols="1" class="text-right font-weight-bold"></v-col>
                        </v-row>
                    </v-container>

                    <span v-if="selectedPersona">
                        <v-row>
                            <v-col cols="4">
                                <v-autocomplete v-model="command.sucursalId" :items="sucursales"
                                    item-text="nombre" item-value="id" label="Sucursal:" placeholder="Seleccione una">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="command.fecha" label="Fecha del Comprobante" type="date" prepend-icon="event"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-checkbox v-model="command.solicitarAutorizacionAFIP" label="Solicitar Autorización"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="command.comentarios"
                                    class="mx-2"
                                    label="Comentarios Adicionales"
                                    prepend-icon="comment"
                                    clearable
                                    auto-grow
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </span>
                    
                </v-container>
            </v-card-text>

            <v-divider></v-divider>  
            <v-card-actions>
                <v-btn color="blue darken-1" text @click.stop="hide(false)">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click.stop="altaNotaCredito" >Confirmar</v-btn>
            </v-card-actions>
        </v-card>
        
        <template v-if="$store.state.debugModeOn">
            Debug Info: <p></p>
            {{}}
            <p></p>                            
        </template>
    </v-container>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'
import { addDays, format } from 'date-fns'
import {Decimal} from 'decimal.js';

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data: () => ({
            saving:false,
            selectedPersona: null,
            listComprobantes: [],
            listDeudasABonificar:[],
            selectedComprobante:[],
            headersComprobantes: [ // definición de columnas
                {text: 'Acción', value:'accion'},
                { text: 'Tipo', value: 'tipo'},
                { text: 'Origen', value: 'origen'},
                { text: 'Numero', value: 'numero'},
                { text: 'Fecha', value: 'fecha', width: 130},
                { text: 'Importe', value: 'importe', width: 130},
                { text: 'Empresa', value: 'empresa'}
            ],
            sucursales:[],
            comentarios:'',
            realizarNotaPara:'ReversarComprobante',
            cargos:[],
            listCargosAAplicar:[],
            cargoAAgregarId:0,
            importeCargoAAgregar:0,
            listComprobantesAReversar:[],
            command:{sucursalId:0,fecha:format(new Date(),('YYYY-MM-DD')),solicitarAutorizacionAFIP:false,comentarios:''}
        }
    ),
    created(){
        this.loadCargos();
        this.loadSucursales();
    },
    computed: {
        ...mapGetters(['getActionFromLink','user']),
       totalCargos: function(){
            if(!this.listCargosAAplicar || this.listCargosAAplicar.length == 0) return 0;

            var total = 0;
            for (let index = 0; index < this.listCargosAAplicar.length; index++) {
                total = total + parseFloat(this.listCargosAAplicar[index].importeAAplicar);
            }
            return total;
        },
        totalAReversar: function(){
            if(!this.listComprobantesAReversar || this.listComprobantesAReversar.length == 0) return 0;

            var total = 0;
            for (let index = 0; index < this.listComprobantesAReversar.length; index++) {
                total = total + parseFloat(this.listComprobantesAReversar[index].importe);
            }
            return total;
        }
    },
    watch:{
        'realizarNotaPara': function(){
            this.listCargosAAplicar = [];
        }
    },
  methods:{
    ...mapMutations(["setActiveTask", "setActiveSubTask", "hideActiveTask", "hideActiveSubTask", 
                        "alertClear", "alertSuccess", "alertWarning", "alertError"]),
    hide(cerrarRelacionados){
        //esto lo hago para que no se buguee cuando lo abro como subtask o task
        if(this.isSubTask)
            this.hideActiveSubTask();
        else
            this.hideActiveTask(cerrarRelacionados);
    },
    limpiar: function(){
        this.selectedPersona = null;
        this.listCargosAAplicar = [];
    },
    setPersona(persona){
        this.selectedPersona = persona;
        this.personaId = persona.personaId;
        this.loadComprobantesPersona();
    },
    async loadComprobantesPersona(){
        this.listComprobantes = [];
        this.loadingComprobantes = true
        try {
            var result = await http.get('personas/listcomprobantesparareversar' 
            + '?empresaId=0'
            + '&id='+ this.personaId); 

            this.listComprobantes = result.list;

            Vue.$log.debug(this.listComprobantes);
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loadingComprobantes = false
    },
    asd(creditoId, item){
        Vue.$log.debug(creditoId);
        Vue.$log.debug(item);
        // agrego hasta la cuota seleccionada mas todas las anteriores
        var listaAAgregar = this.listCreditosActivos.find(d=> d.id == creditoId).detalle.filter(i=> i.cuota <= item.cuota);
        
        var credito = this.listCreditosActivos.find(d=> d.id == creditoId);

        for (let index = 0; index < listaAAgregar.length; index++) {
            const el = listaAAgregar[index];
            
            // veo que ya no esté incluido
            if(this.listDeudasABonificar.find(i=> i.cuotaId == el.id ) != null ) continue;
            
            this.addComprobante(tipo, id, credito.numero, el,
                         el.importeCapital, el.importeInteres, el.importeCargo1, el.importeCargo2, el.importeCargo3, el.importeCargo4, el.importeCargo5);
        }
    },
    addComprobante(item){
        Vue.$log.debug(item);
        var toAdd = {};
        toAdd.tipoComprobante = item.tipo;
        toAdd.numero = item.numero;
        toAdd.comprobanteId = item.id;
        toAdd.importe = item.importe;
        toAdd.fecha = item.fecha;

        this.listComprobantesAReversar.push(toAdd);
    },
    quitarComprobante(item){
        
        // si el concepto es de una cuota de crédito, quito de la seleccinada para adelante
        var indexToRemove = this.listComprobantesAReversar.map(x=>x.comprobanteId).indexOf(item.id);

        this.listComprobantesAReversar.splice(indexToRemove,1);
    },
    agregarCargo()
    {
        if(!this.validarAgregarCargo()) return;

        var cargo = this.cargos.find(c => c.id == this.cargoAAgregarId);
        this.addCargo(  this.importeCargoAAgregar,
                        cargo.descripcion,
                        cargo.id);

        this.cargoAAgregarId = 0;
        this.importeCargoAAgregar = 0;
    },
    addCargo(importeAAplicar, cargoDescripcion, cargoId){
        var toAdd = {};
            
        toAdd.importeAAplicar = importeAAplicar;
        toAdd.cargoDescripcion = cargoDescripcion;
        toAdd.cargoId = cargoId;
        
        this.listCargosAAplicar.push(toAdd);
    },
    quitarCargo(item){
        
        var indexToRemove = this.listCargosAAplicar.map(x=>x.cargoId).indexOf(item.cargoId);

        this.listCargosAAplicar.splice(indexToRemove, 1);
    },
    validarAgregarCargo()
    {
        if(this.listCargosAAplicar.length >= 9)
        {
            this.alertWarning('No se pueden agregar más de 9 cargos en un comprobante.');
            return false;
        }

        if(!this.cargoAAgregarId)
        {
            this.alertWarning('Debe elegir un tipo de cargo para agregar.');
            return false;
        }

        var cargo = this.listCargosAAplicar.find(c => c.cargoId == this.cargoAAgregarId);
        
        if(cargo)
        {
            this.alertWarning('No puede agregar dos cargos del mismo tipo.');
            return false;
        }

        if(!this.importeCargoAAgregar || isNaN(this.importeCargoAAgregar))
        {
            this.alertWarning('El importe del cargo a agregar es inválido. Verifique.');
            return false;
        }

        return true;
    },
    async altaNotaCredito(){
        if(!this.validarAlta()) return;

        var params = {};
        params.personaId = this.personaId;
        params.sucursalId = this.command.sucursalId;
        params.fecha = this.command.fecha;
        params.comentarios = this.command.comentarios;
        params.paraReversarComprobante = this.realizarNotaPara == 'ReversarComprobante';
        params.importeTotal = (this.realizarNotaPara == 'ReversarComprobante' ? this.totalAReversar : this.totalCargos);
        params.pedirAutorizacion = this.command.solicitarAutorizacionAFIP;
        
        //params.detalle = [];

        if(this.realizarNotaPara == 'ReversarComprobante')
            params.detalle = this.listComprobantesAReversar;
        else
            params.detalle = this.listCargosAAplicar;

        try{
            this.saving = true;
            var res = await http.post('comprobantes/altanotacreditofiscal', JSON.stringify( {parametros: params} ) );

            this.alertSuccess('Se ha generado la Nota de Crédito.');
            this.limpiar();
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        
        this.saving = false;
    },
    async loadSucursales(){
      this.loading = true;
      try{
        var result = await http.get('sucursales/list/porusuario?usuarioId='+this.user.id);

        this.sucursales = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadCargos(){
      this.loading = true;
      try{
        var result = await http.get('cargos');

        this.cargos = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    validarAlta(){
        if(!this.personaId)
        {
            this.alertWarning('Debe elegir una persona.');
            return false;
        }

        if(!this.command.sucursalId)
        {
            this.alertWarning('Debe elegir una sucursal.');
            return false;
        }

        if(!this.command.fecha)
        {
            this.alertWarning('Debe ingresar la fecha del comprobante.');
            return false;
        }

        if(this.realizarNotaPara == 'ReversarComprobante')
        {
            if(!this.listComprobantesAReversar || this.listComprobantesAReversar.length == 0)
            {
                this.alertWarning('Debe elegir los comprobantes a reversar.');
                return false;
            }    
        }
        else
        {
            if(!this.listCargosAAplicar || this.listCargosAAplicar.length == 0)
            {
                this.alertWarning('Debe agregar al menos un cargo.');
                return false;
            }
        }

        return true;
    },

  }
}
</script>


